// UPDATE THIS to your actual deployed domain (no trailing slash)
export const SITE_URL = 'https://necexamprep.com';
